// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "spa/js/" + ({"637":"job-search","717":"jobs-page","836":"vision"}[chunkId] || chunkId) + "." + {"319":"b7b00a0d","637":"ecef2864","717":"aa00cfbe","836":"d1255179"}[chunkId] + ".js";
};